<div class="container navtop">


    <div class="row ">


        <div class="col-12 col-lg-6">

            <a class="row justify-content-center" href="https://secure.clem.mobi/NewAbonnement/">

                <img src="../../../assets/img/Picto_Global/carte.png" />

            </a>

        </div>


        <div class="col-12 col-lg-6">

            <a class="row justify-content-center" routerLink="/communaute" routerLinkActive="active">

                <img src="../../../assets/img/Picto_Global/communautes.png" />

            </a>

        </div>



    </div>



    

</div>